"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Industry;
(function (Industry) {
    Industry["TextileAccessories"] = "Textile / Accessories";
    Industry["AutoParts"] = "Auto parts";
    Industry["AutomotiveIndustry"] = "Automotive industry";
    Industry["FoodIndustry"] = "Food industry";
    Industry["Healthcare"] = "Healthcare";
    Industry["Sports"] = "Sports";
    Industry["CosmeticsPerfumes"] = "Cosmetics / Perfumes";
    Industry["Jewelry"] = "Jewelry";
    Industry["Retail"] = "Retail";
    Industry["FurnituresFurnishingsDecoration"] = "Furnitures / Furnishings / Decoration";
    Industry["DiyIndustry"] = "DIY Industry";
    Industry["HouseholdAppliancesMultimedia"] = "Household appliances / Multimedia";
    Industry["Media"] = "Media";
    Industry["Telecommunications"] = "Telecommunications";
    Industry["TravelsTourismHotels"] = "Travels / Tourism / Hotels";
    Industry["ConsumerLendingInsurances"] = "Consumer lending / Insurances";
    Industry["Banks"] = "Banks";
    Industry["Catering"] = "Catering";
    Industry["LeisureCulture"] = "Leisure / Culture";
    Industry["RealEstate"] = "Real estate";
    Industry["SoftwarePublishers"] = "Software publishers";
    Industry["Cashback"] = "Cashback";
    Industry["OnlineBetting"] = "Online betting";
    Industry["Flowers"] = "Flowers";
    Industry["Recruitement"] = "Recruitement";
    Industry["OnlineCoursesLearning"] = "Online courses & learning";
    Industry["Energy"] = "Energy";
    Industry["Toys"] = "Toys";
    Industry["Agencies"] = "Agencies";
    Industry["Services"] = "Services";
    Industry["Watchmaking"] = "Watchmaking";
})(Industry = exports.Industry || (exports.Industry = {}));
//# sourceMappingURL=account.industry.js.map